import packageKey from './packageKey';

export default packageKey;
